/* global gsap */
// UTILS
// ===========================

// Map number x from range [a, b] to [c, d]
const map = (x, a, b, c, d) => (x - a) * (d - c) / (b - a) + c;

// Linear interpolation
const lerp = (a, b, n) => (1 - n) * a + n * b;

let currentBreakpoint;
const calcWindowSize = () => {
	currentBreakpoint = getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-lg');
	return {width: window.innerWidth, height: window.innerHeight};
};

const getRandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);

// Gets the mouse position
const getMousePos = e => {
	return {
		x : e.clientX,
		y : e.clientY
	};
};

const grid_wrapper = document.querySelector('.grid-3d-wrapper') || false;

/**
 * Gets computed translate values
 * @param {HTMLElement} element
 * @returns {Object}
 */



// Calculate the viewport size
let winsize = calcWindowSize();
if (window.innerWidth >= currentBreakpoint) {
	window.addEventListener('resize', () => winsize = calcWindowSize());
}

// Track the mouse position
let mousepos = {x: winsize.width/2, y: winsize.height/2};
if (window.innerWidth >= currentBreakpoint && grid_wrapper) {
	grid_wrapper.addEventListener('mousemove', ev => mousepos = getMousePos(ev));
}

// Classes
// ============================

class GridItem {
	constructor(el) {
		this.DOM = {el: el};
		// the inner image
		this.DOM.image = this.DOM.el.querySelector('.grid__item-img');
		// the title that will appear next to the mouse cursor when hovering
		this.title = this.DOM.el.dataset.title;
		// amounts to move in each axis when moving the cursor
		this.translationVals = {x: 0, y: 0};
		this.rotationVals = {x: 0, y: 0};
		// get random start and end translation/rotation boundaries
		// translation:
		this.xstart = getRandomNumber(10,15);
		this.ystart = getRandomNumber(10,15);

		// rotation:
		// this.rxstart = 5;
		// this.rystart = 10;
		this.rxstart = 0;
		this.rystart = 0;

		// initial style/position
		this.layout();
		// start the rAF render function (translate and rotate the item as we move the mouse)
		this.loopTransformAnimation();
	}

	// initial position on the grid
	// set the rotation and the translationZ
	layout() {

		if (window.innerWidth >= currentBreakpoint) {
			const rect = this.DOM.el.getBoundingClientRect();

			// check if the element is position on the left/top side of the viewport
			this.isLeft = rect.left + rect.width / 2 < winsize.width / 2;
			this.isTop = rect.top + rect.height / 2 < winsize.height / 2;

			this.rY = this.isLeft ?
				map(rect.left + rect.width / 2, 0, winsize.width / 2, this.rystart, 0) :
				map(rect.left + rect.width / 2, winsize.width / 2, winsize.width, 0, -this.rystart);
			this.rX = this.isTop ?
				map(rect.top + rect.height / 2, 0, winsize.height / 2, -this.rxstart, 0) :
				map(rect.top + rect.height / 2, winsize.height / 2, winsize.height, 0, this.rxstart);
			this.tZ = this.isLeft ?
				map(rect.left + rect.width / 2, 0, winsize.width / 2, -200, -600) :
				map(rect.left + rect.width / 2, winsize.width / 2, winsize.width, -600, -200);

			gsap.set(this.DOM.el, {
				rotationX: this.rX,
				rotationY: this.rY,
				z: this.tZ
			});
		}
	}


	loopTransformAnimation() {
		if ( !this.requestId ) {
			this.requestId = requestAnimationFrame(() => this.move());
		}
	}

	// stop the render loop animation (rAF)
	stopTransformAnimation() {
		if ( this.requestId ) {
			window.cancelAnimationFrame(this.requestId);
			this.requestId = undefined;
		}
	}

	// translate/rotate the grid items as we move the mouse
	move() {
		this.requestId = undefined;

		// Calculate the amount to move.
		// Using linear interpolation to smooth things out.
		// Translation values will be in the range of [-start, start] for a cursor movement from 0 to the window's width/height
		this.translationVals.x = lerp(this.translationVals.x, map(mousepos.x, 0, winsize.width, -this.xstart, this.xstart), 0.04);
		this.translationVals.y = lerp(this.translationVals.y, map(mousepos.y, 0, winsize.height, -this.ystart, this.ystart), 0.04);
		// same for the rotations
		this.rotationVals.x = this.isTop ? lerp(this.rotationVals.x, map(mousepos.y, 0, winsize.height/2, this.rxstart, 0), 0.04) : lerp(this.rotationVals.x, map(mousepos.y, winsize.height/2, winsize.height, 0, -this.rxstart), 0.04);
		this.rotationVals.y = this.isLeft ? lerp(this.rotationVals.y, map(mousepos.x, 0, winsize.width/2, -this.rystart, 0), 0.04) : lerp(this.rotationVals.y, map(mousepos.x, winsize.width/2, winsize.width, 0, this.rystart), 0.04);

		gsap.set(this.DOM.el, {
			x: -this.translationVals.x,
			y: -this.translationVals.y,
			rotationX: -this.rX-this.rotationVals.x,
			rotationY: -this.rY-this.rotationVals.y
		});

		this.loopTransformAnimation();
	}
}

export default class Grid {
	constructor(el) {
		this.DOM = {el: el};

		this.gridItems = [];
		this.DOM.items = Array.from(this.DOM.el.querySelectorAll('.grid__item'));
		this.DOM.items.forEach(item => {
			this.gridItems.push(new GridItem(item));
		});

		this.showItems();
	}

	// Initial animation to scale up and fade in the items
	showItems() {
		gsap.set(this.DOM.items, {scale: 1, opacity: 1}, 0);
	}
}

